<div class="addressbar">
  <span class="addresstext">Radni nalozi / Kontrolna ploča</span>
</div>
<div class="containerpadding">
  <h1>Kontrolna ploča radnih naloga</h1>
  <hr />
  <div class="row">
    <div class="col-12 col-lg-6">
      <app-chart-kvarovi></app-chart-kvarovi>
    </div>
    <div class="col-12 col-lg-6">
      <app-chart-serviseri></app-chart-serviseri>
    </div>
  </div>
  </div>
